if (!customElements.get('testimonials-slider')) {
  class TestimonialSlider extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.sliderElement = this.querySelector('[data-swiper]');
      this.arrows = {
        left: this.querySelector('.swiper-prev'),
        right: this.querySelector('.swiper-next'),
      };

      if (!this.sliderElement) return;

      this.initSwiper();
      this.updateArrows(); // Initial check for arrows

      window.addEventListener('resize', this.updateArrows.bind(this));
    }

    initSwiper() {
      try {
        const swiperConfig = this.sliderElement.getAttribute('data-swiper');
        if (swiperConfig) {
          theme.SwiperSlide(this.sliderElement, JSON.parse(swiperConfig));
        }
      } catch (error) {
        console.warn('Swiper initialization failed:', error);
      }
    }

    updateArrows() {
      const itemsCount = this.querySelectorAll('[testimonial-item]').length;
      const screenWidth = window.innerWidth;

      if (!this.arrows.left || !this.arrows.right) return;

      let shouldShowArrows = false;
      if (screenWidth <= 768) {
        shouldShowArrows = itemsCount > 1;
      } else if (screenWidth <= 1440) {
        shouldShowArrows = itemsCount > 2;
      } else {
        shouldShowArrows = itemsCount > 3;
      }
      this.arrows.left.style.display = shouldShowArrows ? 'block' : 'none';
      this.arrows.right.style.display = shouldShowArrows ? 'block' : 'none';
    }
  }

  customElements.define('testimonials-slider', TestimonialSlider);
}
